import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getFinalValue = (data, name) => {
  if (name.includes('.')) {
    const [relationName, fieldName] = name.split('.');
    if (Array.isArray(data[relationName])) {
      return data[relationName].reduce((str, element, index) => `${str}${index ? ',' : ''}${element[fieldName]}`, '');
    }
    return data[relationName] ? data[relationName][fieldName] : data[fieldName] || '';
  }
  return data[name];
};
const buildProps = (props, data) => props.reduce((acc, {
  label: key,
  propertiesToDisplay: [name],
  staticMetric
}) => {
  if (key && (staticMetric || name)) {
    acc[key] = staticMetric || getFinalValue(data, name);
  }
  return acc;
}, {});
const buildDataLayerProps = (props, data) => Array.isArray(data) ? data.map(currentData => buildProps(props, currentData)) : buildProps(props, data);
const buildDataLayer = (data, propsToDisplay, url) => {
  if (!propsToDisplay || !propsToDisplay.length) return null;
  const propsToDisplayValues = buildDataLayerProps(propsToDisplay, data);
  return url ? _objectSpread({
    event: 'pageView',
    url
  }, propsToDisplayValues) : propsToDisplayValues;
};
export default buildDataLayer;
//# sourceMappingURL=build-data-layer.js.map